export function extractLastSegment(urlPath:string) {
    return urlPath.substring(urlPath.lastIndexOf("/")+1);
}